import React, { useEffect, useState, useRef } from 'react'
import useApp from 'hooks/useApp'
import Global from 'library/Global'
import Lib from 'library'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button } from 'components'
import styles from './index.module.css'
import Native from 'library/native'

const ThinkPayBefore = () => {

	const App = useApp()
	const navigate = useNavigate()
	const location = useLocation();

	const [prodList, setProdList] = useState(); // 상품목록 조회
	const [payProdList, setPayProdList] = useState(); // 결제 상품목록 조회
	const [mbStockInsttProdList, setMbStockInsttProdList] = useState(); // 회원별 증권사별 목록

	const mounted = useRef()

	useEffect(() => {

		mounted.current = true
		console.log('location 확인!!!!! >> ', location)
		// console.log('navigate(-1) 확인!!!!! >> ', navigate(-1))
		App.setHeader({
			show: true,
			title: <></>,
			// left: <i className="icon icon_arrow_back" onClick={App.goBack ? App.goBack : navigate('Finance')} />,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: undefined,
		})

		App.setShowNav(false)
		App.setMainClass("white")

		mounted && getProdList("0");
		//mounted && getStockPayProdList();
		mounted && getStockInsttProdList();

		return () => {
			mounted.current = false
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])
	useEffect(() => {
		console.log('AppApp >> ', App)
	}, [App])

	useEffect(() => {
		if (prodList && prodList.length > 0) {
			getStockPayProdList();
		}
	}, [prodList])

	// 바우처 상품목록조회 gb(0:최초, 1: 상품정보 수정 후 다시 조회)
	const getProdList = (gb) => {
		// 상품 목록 조회
		Lib.post("/api/inner/thinkpool/stock/prod/list", data => {
			if (gb === "0") {
				setProdList(data);
			} else {
				setPayProdList(data);
			}

		})
	}

	// 바우처 상품정보 수정
	const updateProdInfo = (prodInfo) => {
		Lib.post("/api/inner/thinkpool/stock/prod/update"
			, {
				prodId: prodInfo.prodId,
				prodNm: prodInfo.prodNm,
				prodConts: prodInfo.prodConts,
				prodAmt: prodInfo.prodAmt
			}
			, data => {
				// 상품 목록 조회
				getProdList("1");
			})
	}

	// 주식 바우처(결제) 상품목록 조회
	const getStockPayProdList = () => {
		// console.log("getStockPayProdList")
		//let productId = "my_stock_manager";
		let productIdList = [];

		for (let item of prodList) {
			let productId = item.prodId;

			if (Lib.checkMobile() === "android") {
				productId = productId.toLowerCase();
			}
			productIdList.push(productId);
		}

		// if (prodList && prodList.length > 0) {
		// 	productId = prodList[0].prodId;
		// }

		// if (Lib.checkMobile() === "android") {
		// 	productId = productId.toLowerCase();
		// }
		//App.alert("productId===[" + productId + "]");

		if (Global.test) {

			let resultCode = "0";
			let resultData = { title: "My Stock Manager", description: "My Stock Manager를 사용합니다.", productId: "my_stock_manager", price: "₩29,000" };
			let prodInfo = {};
			// App.alert("resultCode===["+resultCode+"]");
			// App.alert("resultData===["+resultData+"]");
			if (resultCode !== "0") {
				App.alert(resultData);
				return;
			}

			prodInfo.prodId = resultData.productId;
			prodInfo.prodNm = resultData.title;
			prodInfo.prodConts = resultData.description;
			prodInfo.prodAmt = resultData.price.replace(/₩/gi, "").replace(",", "");
			// App.alert("prodInfo.prodAmt===["+prodInfo.prodAmt+"]");
			// 상품정보 수정 및 상품 재조회
			updateProdInfo(prodInfo);
		} else {
			for (let prodIdItem of productIdList) {
				Native.execute("IAP", "productInfo", function (result) {
					console.log(JSON.parse(result).result);
					let resultCode = JSON.parse(result).resultCode;
					let resultData = JSON.parse(result).result;
					let prodInfo = {};
					// App.alert("resultCode===["+resultCode+"]");
					// App.alert("resultData===["+resultData+"]");
					if (resultCode !== "0") {
						App.alert(resultData);
						return;
					}

					prodInfo.prodId = resultData.productId;
					prodInfo.prodNm = resultData.title;
					prodInfo.prodConts = resultData.description;
					prodInfo.prodAmt = resultData.price.replace(/₩/gi, "").replace(",", "");
					// App.alert("prodInfo.prodAmt===["+prodInfo.prodAmt+"]");
					// 상품정보 수정 및 상품 재조회
					updateProdInfo(prodInfo);
				}, {
					productId: prodIdItem
				})
			}

		}
	}

	// 회원별 증권사(기관)별 상품목록 조회
	const getStockInsttProdList = () => {
		Lib.post("/api/inner/thinkpool/mb/stock/instt/item/list", data => {
			setMbStockInsttProdList(data);
		})
	}

	// 구매하기 버튼 클릭시 이동
	const goPay = (prodId) => {
		if (mbStockInsttProdList && mbStockInsttProdList.length > 0) {
			let receiptNo = "";
			let receiptData = "";
			let payYn = "";

			if (Global.test) {
				let resultCode = "0";
				let resultData = {
					receiptData: "MIIT2QYJKoZIhvcNAQcCoIITyjCCE8YCAQExCzAJBgUrDgMCGgspEg3mSkl0r3e3tk/wAu+7If3mZLahUhfQZ9h0UVM2NZew0Ro",
					transactionId: "2000000104115325"
				};

				App.alert("resultCode==" + resultCode);
				App.alert("resultData==" + resultData);

				if (resultCode !== "0") {
					payYn = "N";
					App.alert(resultData);
					//return;
				} else {
					payYn = "Y";
					receiptNo = resultData.transactionId;
					receiptData = resultData.receiptData;
				}

				App.alert("receiptNo==" + receiptNo);
				App.alert("prodId==" + prodId);

				Lib.post("/api/inner/thinkpool/mb/stock/voucher/pay/save"
					, {
						prodId: prodId,
						receiptNo: receiptNo,
						payYn: payYn,
						resultCode: resultCode,
						receiptData: receiptData
					}
					, data => {
						// 완료 페이지로 이동 
						navigate("/thinkpool/thinkPayAfter", {
							state:
							{
								prodId: prodId,
								receiptNo: receiptNo,
								fromGb: location.state?.fromGb,
								backUrl: location.state?.backUrl,
								purchasedUrl: location.state?.purchasedUrl
							}
						})
					})
			} else {
				console.log("결제 페이지로 이동 네이티브")
				Native.execute("IAP", "purchase", function (result) {
					console.log(JSON.parse(result).result)

					let resultCode = JSON.parse(result).resultCode;
					let resultData = JSON.parse(result).result;

					//App.alert("resultCode==" + resultCode);
					//App.alert("resultData==" + resultData);
					if (resultCode !== "0") {
						payYn = "N";
						//App.alert(resultData);
						//return;
					} else {
						payYn = "Y";
						receiptNo = resultData.transactionId;
						receiptData = resultData.receiptData;
					}

					//App.alert("receiptNo==" + receiptNo);

					Lib.post("/api/inner/thinkpool/mb/stock/voucher/pay/save"
						, {
							prodId: prodId,
							receiptNo: receiptNo,
							payYn: payYn,
							resultCode: resultCode,
							receiptData: receiptData
						}
						, data => {
							if (resultCode === "0") {
								// 완료 페이지로 이동 
								navigate("/thinkpool/thinkPayAfter", {
									state:
									{
										prodId: prodId,
										receiptNo: receiptNo,
										fromGb: location.state?.fromGb,
										backUrl: location.state?.backUrl,
										purchasedUrl: location.state?.purchasedUrl
									}
								})
							}
						})

				}, {
					productId: prodId
					// productId: "my_stock_manager"
				})
			}
		} else {
			App.alert("보유종목이 없어 구매가 불가능해요!");
		}
	}

	// 씽크풀로 이동
	const goThinkPool = (backUrl) => {
		console.log("go hinkpool");
		let url = App.thinkPoolServer + "?mbId=" + window.localStorage.getItem("mbId") + "&fromType=purchase";

		if (backUrl) {
			url = backUrl + "?mbId=" + window.localStorage.getItem("mbId") + "&fromType=purchase";
		}

		Native.execute("Popup", "openPopup", undefined, { url: url, fullscreen: "Y", backPress: "Y" })

		// console.log("App.thinkPoolServer url", url);
		// //window.open(url, '_blank');
		// window.location.href = url;
	}

	return (
		<div className="page">
			<div className="flex_1 padding">
				<div className={styles.title}>상품구매</div>
				<div className={`${styles.guide} mt_40`}>
					내 보유종목의 매매신호를 더 자세히 알고싶다면?
					<span className="text-blue" style={{ verticalAlign: "inherit" }}>AI매매신호 프리미엄</span>에 가입하세요!
				</div>

				<ul className={`${styles["prod-box"]} mt_30`}>
					<li>
						<i className="icon icon_think_product01" />
						<div>나만을 위한<br />매매신호</div>
					</li>
					<li>
						<i className="icon icon_think_product02" />
						<div>구매 후 1개월<br />동안 사용 가능</div>
					</li>
					<li>
						<i className="icon icon_think_product03" />
						<div>모든 보유종목<br />확인 가능</div>
					</li>
				</ul>

				{
					mbStockInsttProdList && mbStockInsttProdList.length > 0 ?
						<>
							{/* 보유종목이 있는 경우 */}
							{
								payProdList ?
									payProdList.map((item, idx) => {
										return (
											<div key={idx} className={`${styles["prod-area"]} ${styles["ellipsis"]} mt_30`}>
												<div>
													<p>{item.prodNm}</p>
													<strong className={styles.price}>{Lib.addComma(item.prodAmt)}원</strong>
												</div>
												<span className={styles.btn} onClick={() => goPay(item.prodId)}>구매하기</span>
											</div>
										)
									})
									:
									""
							}
						</>
						:
						<>
							{/* 보유종목이 없거나 금융투자업권이 연동되지 않은 경우 */}
							{
								payProdList ?
									payProdList.map((item, idx) => {
										return (
											<React.Fragment key={idx}>
												<div className={`${styles["prod-area"]} mt_30`}>
													<div>
														<p>{item.prodNm}</p>
														<strong className={styles.price}>{Lib.addComma(item.prodAmt)}원</strong>
													</div>
													<span className={styles.btn} style={{ background: "#d4d4d4" }} onClick={goPay}>구매하기</span>
												</div>
												{/* <div className="mt_10 ml_5 text-red" style={{ fontSize: "1.2rem" }}>보유종목이 없어 구매가 불가능해요!</div> */}
											</React.Fragment>
										)
									})
									:
									""
							}
						</>
				}

				<div className={`${styles["notice-box"]} mt_30`}>
					<p>안내</p>
					<ul className="mt_10">
						<li>- 모든 결제는 앱스토어를 통해 진행되며, 등록된 결제수단을 이용해 결제가 가능합니다.</li>
						<li>- 모든 상품은 결제와 동시에 서비스 이용이 가능하므로 서비스가 개시된 결제상품에 대해 취소/환불은 어렵습니다.</li>
						<li>- 구매 시점부터 30일 후 23시 59분까지 서비스 이용이 가능하며, 1개월 이후 부터는 새롭게 구매하셔야 프리미엄 콘텐츠를 이용할 수 있습니다.</li>
						<li>- 기타 문의사항을 설정 &gt; 사용자 문의하기를 통해 남겨주시면 최대한 빠른 시일내에 답변해드리겠습니다.</li>
					</ul>
				</div>
			</div>

			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big btn--dark" onClick={() => goThinkPool(location.state?.backUrl)}>건너뛰기</Button>
			</div>

			{
				// location && location.state && location.state.fromGb === "thinkpool" ?
				// 	<div className="flex-shrink_0 padding">
				// 		<Button className="btn btn--big" onClick={() => goThinkPool(location.state?.backUrl)}>메인으로 가기</Button>
				// 	</div>
				// 	:
				// 	<div className="flex-shrink_0 padding">
				// 		<Button className="btn btn--big btn--dark" onClick={()=>goThinkPool(location.state?.backUrl)}>건너뛰기</Button>
				// 	</div>
			}

		</div>
	)
}

export default ThinkPayBefore